/**
 * @file: orgUserUtils.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { OrgUserRoleType } from '@euler/model/enum';
import { uniq } from 'ramda';

export const roleStringToUserRoles = (role: string | null | undefined) => {
  return uniq(
    (role ?? '')
      .split(/\s*,\s*/g)
      .map(x => x.trim())
      .filter(x => x),
  ) as OrgUserRoleType[];
};

export const getOrgUserRoleTypeLabels = (
  role: string | null | undefined,
): string[] => {
  const roles = roleStringToUserRoles(role);
  const labels: string[] = [];
  if (roles?.includes(OrgUserRoleType.Administrator)) {
    labels.push('管理员');
  }
  if (roles?.includes(OrgUserRoleType.Manager)) {
    labels.push('门店经理');
  }
  if (roles?.includes(OrgUserRoleType.ServiceAgents)) {
    labels.push('服务顾问');
  }
  if (roles?.includes(OrgUserRoleType.Technicians)) {
    labels.push('维保技师');
  }
  if (roles?.includes(OrgUserRoleType.Marketer)) {
    labels.push('营销专员');
  }
  return labels;
};

export const orgUserRoleContains = (
  role: string | null | undefined,
  roleType: OrgUserRoleType,
) => {
  return roleStringToUserRoles(role).includes(roleType);
};
